import * as React from "react";

const TabPanel = (
  props: {
    children?: JSX.Element | null;
    render?: (children?: JSX.Element | null) => JSX.Element | null;
    dismount?: boolean;
  } & (
    | {
        value: number;
        index: number;
      }
    | {
        value: string;
        index: string;
      }
  )
) => {
  const { children, value, index, render, dismount = true } = props;
  if (!dismount) {
    return (
      <div style={value !== index ? { display: "none" } : {}}>{children}</div>
    );
  }
  return value === index ? render?.(children) ?? children ?? null : null;
};

export default TabPanel;
